import React from 'react';

import classNames from 'classnames';
import { get } from 'lodash';

const AuroraTextField = props => {
  const { metadata } = props;
  const { label, attributes, id } = metadata;
  const className = get(attributes, 'className', '');
  return (
    <div
      id={id}
      className={classNames(
        className,
        'control-label tw-border-1 pb-3 tw-flex tw-items-center tw-space-x-2'
      )}
    >
      <p>{label}</p>
    </div>
  );
};

export default AuroraTextField;
